// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccountDeletionController from "./account_deletion_controller"
application.register("account-deletion", AccountDeletionController)

import AccountDeletionFormController from "./account_deletion_form_controller"
application.register("account-deletion-form", AccountDeletionFormController)

import AppDownloadRedirectController from "./app_download_redirect_controller"

application.register("app-download-redirect", AppDownloadRedirectController)

import AppleIapPaymentController from "./apple_iap_payment_controller"

application.register("apple-iap-payment", AppleIapPaymentController)

import AudioPlayerController from "./audio_player_controller"
application.register("audio-player", AudioPlayerController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import BulkPeopleSelectionController from "./bulk_people_selection_controller"
application.register("bulk-people-selection", BulkPeopleSelectionController)

import CardFlipController from "./card_flip_controller"
application.register("card-flip", CardFlipController)

import CarouselController from "./carousel_controller"
application.register("carousel", CarouselController)

import CharacterCounterController from "./character_counter_controller"
application.register("character-counter", CharacterCounterController)

import CityAutocompleteController from "./city_autocomplete_controller"
application.register("city-autocomplete", CityAutocompleteController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ComposingController from "./composing_controller"
application.register("composing", ComposingController)

import ContactInviteController from "./contact_invite_controller"
application.register("contact-invite", ContactInviteController)

import ContactPickerController from "./contact_picker_controller"
application.register("contact-picker", ContactPickerController)

import ContactsImportController from "./contacts_import_controller"
application.register("contacts-import", ContactsImportController)

import ContextMenuController from "./context_menu_controller"

application.register("context-menu", ContextMenuController)

import CountdownController from "./countdown_controller"
application.register("countdown", CountdownController)

import CountryFilterController from "./country_filter_controller"
application.register("country-filter", CountryFilterController)

import CountrySelectorController from "./country_selector_controller"
application.register("country-selector", CountrySelectorController)

import DisableSubmitController from "./disable_submit_controller"
application.register("disable-submit", DisableSubmitController)

import DobController from "./dob_controller"
application.register("dob", DobController)

import DrawerTriggerController from "./drawer_trigger_controller"
application.register("drawer-trigger", DrawerTriggerController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import DualRangeSliderController from "./dual_range_slider_controller"
application.register("dual-range-slider", DualRangeSliderController)

import EventFormController from "./event_form_controller"
application.register("event-form", EventFormController)

import EventMediaFormController from "./event_media_form_controller"
application.register("event-media-form", EventMediaFormController)

import ExpandableTextController from "./expandable_text_controller"
application.register("expandable-text", ExpandableTextController)

import FilePreviewController from "./file_preview_controller"
application.register("file-preview", FilePreviewController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import FlutterPermissionsController from "./flutter_permissions_controller"
application.register("flutter-permissions", FlutterPermissionsController)

import FriendsPickerController from "./friends_picker_controller"
application.register("friends-picker", FriendsPickerController)

import AutoOpenDrawerController from "./auto_open_drawer_controller"
application.register("auto-open-drawer", AutoOpenDrawerController)

import GlobalDrawerController from "./global_drawer_controller"
application.register("global-drawer", GlobalDrawerController)

import GlobalDrawerTriggerController from "./global_drawer_trigger_controller"
application.register("global-drawer-trigger", GlobalDrawerTriggerController)

import HeaderSearchController from "./header_search_controller"

application.register("header-search", HeaderSearchController)

import ImageViewerController from "./image_viewer_controller"
application.register("image-viewer", ImageViewerController)

import InfiniteScrollController from "./infinite_scroll_controller"
application.register("infinite-scroll", InfiniteScrollController)

import InputAutoSubmitController from "./input_auto_submit_controller"
application.register("input-auto-submit", InputAutoSubmitController)

import InterestsController from "./interests_controller"

application.register("interests", InterestsController)

import IpadosDetectController from "./ipados_detect_controller"

application.register("ipados-detect", IpadosDetectController)

import LoadMoreMessagesController from "./load_more_messages_controller"
application.register("load-more-messages", LoadMoreMessagesController)

import LocationSelectController from "./location_select_controller"
application.register("location-select", LocationSelectController)

import LogoutController from "./logout_controller"
application.register("logout", LogoutController)

import MediaViewerTriggerController from "./media_viewer_trigger_controller"
application.register("media-viewer-trigger", MediaViewerTriggerController)

import MentionController from "./mention_controller"

application.register("mention", MentionController)

import MessageFormController from "./message_form_controller"
application.register("message-form", MessageFormController)

import MessageMediaController from "./message_media_controller"
application.register("message-media", MessageMediaController)

import MessagesScrollController from "./messages_scroll_controller"
application.register("messages-scroll", MessagesScrollController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import OnboardingController from "./onboarding_controller"
application.register("onboarding", OnboardingController)

import OnesignalDeviceController from "./onesignal_device_controller"
application.register("onesignal-device", OnesignalDeviceController)

import OtpInputController from "./otp_input_controller"
application.register("otp-input", OtpInputController)

import PodcastFormController from "./podcast_form_controller"
application.register("podcast-form", PodcastFormController)

import PostFormController from "./post_form_controller"
application.register("post-form", PostFormController)

import PrelineModalCloseButtonController from "./preline_modal_close_button_controller"
application.register("preline-modal-close-button", PrelineModalCloseButtonController)

import ProfessionSearchController from "./profession_search_controller"
application.register("profession-search", ProfessionSearchController)

import ProfileHeaderVisibilityController from "./profile_header_visibility_controller"

application.register("profile-header-visibility", ProfileHeaderVisibilityController)

import ProfilePictureController from "./profile_picture_controller"
application.register("profile-picture", ProfilePictureController)

import PullToRefreshController from "./pull_to_refresh_controller"
application.register("pull-to-refresh", PullToRefreshController)

import PushNotificationRedirectController from "./push_notification_redirect_controller"

application.register("push-notification-redirect", PushNotificationRedirectController)

import RadioResetController from "./radio_reset_controller"

application.register("radio-reset", RadioResetController)

import ReactionsOverlayController from "./reactions_overlay_controller"

application.register("reactions-overlay", ReactionsOverlayController)

import ReactionsPickerController from "./reactions_picker_controller"

application.register("reactions-picker", ReactionsPickerController)

import RecordCommentsController from "./record_comments_controller"
application.register("record-comments", RecordCommentsController)

import ReferralController from "./referral_controller"
application.register("referral", ReferralController)

import RefreshController from "./refresh_controller"
application.register("refresh", RefreshController)

import RegistrationController from "./registration_controller"
application.register("registration", RegistrationController)

import ReplyController from "./reply_controller"
application.register("reply", ReplyController)

import ResendOtpController from "./resend_otp_controller"
application.register("resend-otp", ResendOtpController)

import RichFormController from "./rich_form_controller"
application.register("rich-form", RichFormController)

import CameraCaptureController from "./camera_capture_controller"
application.register("camera-capture", CameraCaptureController)

import ScrollCollapseController from "./scroll_collapse_controller"

application.register("scroll-collapse", ScrollCollapseController)

import ShareController from "./share_controller"
application.register("share", ShareController)

import ShareIntentReadyController from "./share_intent_ready_controller"

application.register("share-intent-ready", ShareIntentReadyController)

import SubmitWithSpinnerController from "./submit_with_spinner_controller"
application.register("submit-with-spinner", SubmitWithSpinnerController)

import SwipeReplyController from "./swipe_reply_controller"

application.register("swipe-reply", SwipeReplyController)

import TestimonialFormController from "./testimonial_form_controller"
application.register("testimonial-form", TestimonialFormController)

import TranslationToggleController from "./translation_toggle_controller"

application.register("translation-toggle", TranslationToggleController)

import VideoRecorderController from "./video_recorder_controller"
application.register("video-recorder", VideoRecorderController)

import WebcamController from "./webcam_controller"
application.register("webcam", WebcamController)

import WelcomeRedirectController from "./welcome_redirect_controller"
application.register("welcome-redirect", WelcomeRedirectController)
